import { defineComponent as o, computed as n } from "vue";
const i = /* @__PURE__ */ o({
  __name: "offer-tile-list",
  props: {
    offers: { default: void 0 },
    spaces: { type: Boolean }
  },
  setup(t) {
    const r = t, f = n(
      () => r.offers?.filter((e) => "product" in e ? !!e.product?.articleNumber : "offer" in e ? !!e.offer?.product?.articleNumber : !1) || []
    );
    return { __sfc: !0, props: r, entriesWithProduct: f };
  }
});
export {
  i as default
};
